import { render, staticRenderFns } from "./ChrismastBanner.vue?vue&type=template&id=5eb9e20c&scoped=true&"
import script from "./ChrismastBanner.vue?vue&type=script&lang=js&"
export * from "./ChrismastBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChrismastBanner.vue?vue&type=style&index=0&id=5eb9e20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9e20c",
  null
  
)

export default component.exports